<template>
  <transition v-if="found" name="fade" mode="out-in" appear>
    <router-view></router-view>
  </transition>
</template>

<script>
export default {
  data: () => ({
    found: false
  }),
  beforeMount () {
    this.beforeEnter()
  },
  methods: {
    beforeEnter () {
      const params = this.$route.params
      const url = params.courseKey
      if (this.$store.getters.courseByKey(url)) this.found = true
      else {
        const appMsg = {
          type: 'error',
          msg: 'Course not found'
        }
        this.$store.dispatch('showAppMsg', appMsg)
        this.$router.push('/manage-courses')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/courses/CourseWrap.vue